exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-right[data-v-3a8ebaf6]{position:absolute;right:10px;top:18px}.title[data-v-3a8ebaf6]{font-size:85px}footer[data-v-3a8ebaf6]{background-image:url(/images/footer-back-min.png)!important;background-size:contain!important;background-repeat:round!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a8ebaf6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/layouts/website.vue
// module id = z7Cw
// module chunks = 12